import { render, staticRenderFns } from "./ProductBoutique.vue?vue&type=template&id=693a3fdc&scoped=true&"
import script from "./ProductBoutique.vue?vue&type=script&lang=js&"
export * from "./ProductBoutique.vue?vue&type=script&lang=js&"
import style0 from "./ProductBoutique.vue?vue&type=style&index=0&id=693a3fdc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693a3fdc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoryblokImage: require('/opt/build/repo/components/StoryblokImage.vue').default,BoutiqueInfos: require('/opt/build/repo/components/BoutiqueInfos.vue').default,AppButton: require('/opt/build/repo/components/AppButton.vue').default})
